import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div className={className} initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }} transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}>
    {children}
  </motion.div>
);

export const SectionHead = ({ eyebrow, title, children }) => (
  <div className="max-w-2xl">
    <p className="eyebrow">{eyebrow}</p>
    <h2 className="mt-4 font-display text-3xl sm:text-4xl tracking-tight leading-tight">{title}</h2>
    {children && <p className="mt-4 text-[#57534E] leading-relaxed">{children}</p>}
  </div>
);
